module.exports = __webpack_public_path__ + "static/media/lito_lookbook.88299080.png";